import { Container, AnimatedCircle1, AnimatedCircle2, AnimatedCircle3 } from './styles';

const Loader = (props) => {
    const colors = [
        "#FFFD82",
        "#1B998B",
        "#2D3047",
        "#FF9B71",
        "#E84855",
        "#F7EC59",
        "#FF66D8",
        "#92DCE5",
        "#FF3366",
        "#2EC4B6"
    ]

    const getRandomStroke = () => {
        return colors[Math.floor(Math.random()*colors.length)];
    } 

    const scale = props.scale ? props.scale : 1;

    return (
        <Container>
            <svg width={(112*scale).toString()} height={(150*scale).toString()} viewBox="0 0 224 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                <AnimatedCircle1 cx="112.383" cy="100.184" r="49" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle3 cx="68.6987" cy="125" r="49" transform="rotate(-120 68.6987 125)" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle2 cx="155.301" cy="75" r="49" transform="rotate(-120 155.301 75)" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle2 cx="155.301" cy="125" r="49" transform="rotate(120 155.301 125)" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle3 cx="68.6987" cy="75" r="49" transform="rotate(120 68.6987 75)" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle1 cx="112" cy="50" r="49" stroke={getRandomStroke()} stroke-width="2"/>
                <AnimatedCircle1 cx="112" cy="150" r="49" stroke={getRandomStroke()} stroke-width="2"/>
            </svg>
        </Container>
    )
}

export default Loader;